var _defs, _line, _line2, _line3, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUserTopLists = function SvgUserTopLists(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    stroke: "#FFFFFF",
    opacity: 0.8,
    strokeLinejoin: "round",
    strokeWidth: "5.37px",
    strokeLinecap: "round",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke-linecap:round;}.a,.b,.c{stroke:#FFF;stroke-miterlimit:10;}.a{stroke-width:5.37px;}.b{stroke-width:5.34px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 17.5,
    y1: 89,
    x2: 17.5,
    y2: 11
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 39.5,
    y1: 88.5,
    x2: 39.5,
    y2: 11.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 79.28,
    y1: 89.55,
    x2: 53.5,
    y2: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M93.91,35.31c1.36-3.76.19-6.43-3.41-8.57-3.85-2.29-3.85-2.29-1.54-5.95a8.16,8.16,0,0,0-.19-8.74,7.14,7.14,0,0,0-12.89,3.81,7.79,7.79,0,0,0,2.43,6.56c1.3,1.29,1.15,2.21-.51,3a25.92,25.92,0,0,0-3.45,2c-2.72,1.92-3.63,4.88-2.19,7.77a8,8,0,0,1,4.74-8.07c4.39-2.28,4.31-2.43,1.36-6.56a8.17,8.17,0,0,1-.54-.85,6.6,6.6,0,0,1,1-7.63,5.77,5.77,0,0,1,6.87-1.28,5.84,5.84,0,0,1,3.28,6.64,14.67,14.67,0,0,1-2.56,4.71c-1,1.38-1.42,2.66.26,3.56C90.45,27.83,94.29,29.83,93.91,35.31Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserTopLists, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-top-lists.14710625.svg";
export { ForwardRef as ReactComponent };